export const makeRequest = (query, variables) => ({
  url: "/api",
  method: "post",
  data: {
    query,
    variables,
  },
});

export const getResponseData = () => {
  // Do something
};

export const getCsrfToken = () => {
  const name = document
    .querySelector('meta[name="csrfTokenName"]')
    .getAttribute("content");

  const token = document
    .querySelector('meta[name="csrfToken"]')
    .getAttribute("content");

  return { [name]: token };
};
